import { RpcService } from 'rpc';

import { SiteAccess } from '../interfaces';

export declare interface AMService extends RpcService {
	products(): Promise<SiteAccess[]>;
}

export const svc: AMService = new RpcService({
	transport: 'POST',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `/am/@@user.rpc`,

	services: {
		products: {
			cacheable: true,
			cacheLifetime: 24,
			parameters: []
		}
	}
}) as AMService;

export default svc;
